import { useLoginStore } from '@/login/stores/useLoginStore';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { ClusterTags, CreateClusterTagInput, UpdateClusterTagInput, DeleteClusterTagInput } from '@sysarb/sysarb-types-v2/services/v1/job';
import type { UseMutationOptions, QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type JobClustersOptions = {
    queries: {
        getClusterTags: (subscribe?: boolean) => QueryOptions<ClusterTags | null, Error>;
    };
    mutations: {
        create: UseMutationOptions<boolean, Error, CreateClusterTagInput>;
        update: UseMutationOptions<boolean, Error, UpdateClusterTagInput>;
        delete: UseMutationOptions<boolean, Error, DeleteClusterTagInput>;
    };
};

export const jobClusters: JobClustersOptions = {
    queries: {
        getClusterTags: (subscribe: boolean = true): QueryOptions<ClusterTags | null, Error> => {
            const { instanceTopic } = useLoginStore();
            return queryOptions<ClusterTags | null, Error>({
                meta: {
                    subscribe,
                    type: 'resgate',
                    resourceId: `v1.${instanceTopic}.clustertags`,
                },
                queryKey: ['clusterTags', instanceTopic],
                queryFn: async (): Promise<ClusterTags | null> => {
                    if (instanceTopic == null) {
                        throw new Error('Invalid subdomain');
                    }
                    return ResgateManager.model<ClusterTags>(`v1.${instanceTopic}.clustertags`).then(res => {
                        if (res instanceof ResErr) {
                            throw new Error(res.message);
                        }
                        return res;
                    });
                },
            });
        }
    },
    mutations: {
        create: {
            mutationFn: async (payload: CreateClusterTagInput): Promise<boolean> => {
                const { instanceTopic } = useLoginStore();
                const resgate = ResgateManager.getInstance();
                return resgate.call<void>(`v1.${instanceTopic}.clustertags`, 'create', payload).then(res => {
                    if (res instanceof ResErr) {
                        throw new Error(res.message);
                    }
                    return true;
                });
            }
        },
        update: {
            mutationFn: async (payload: UpdateClusterTagInput): Promise<boolean> => {
                const { instanceTopic } = useLoginStore();
                const resgate = ResgateManager.getInstance();
                return resgate.call<void>(`v1.${instanceTopic}.clustertags`, 'update', payload).then(res => {
                    if (res instanceof ResErr) {
                        throw new Error(res.message);
                    }
                    return true;
                });
            }
        },
        delete: {
            mutationFn: async (payload: DeleteClusterTagInput): Promise<boolean> => {
                const { instanceTopic } = useLoginStore();
                const resgate = ResgateManager.getInstance();
                return resgate.call<void>(`v1.${instanceTopic}.clustertags`, 'delete', payload).then(res => {
                    if (res instanceof ResErr) {
                        throw new Error(res.message);
                    }
                    return true;
                });
            }
        }
    }
};
